import React from 'react';
import { SignInFooter, Link } from '../styled';
import {
  maybeDiscover,
  maybeActivationEmail
} from '../../ext/tracking/location-based-tracking';

export const RETURNING_USER_TEST_ID = 'returning-user';

export interface ReturningUserFooterProps {
  skipRender?: boolean;
}

export const ReturningUserFooter: React.FC<ReturningUserFooterProps> = props => {
  const { skipRender } = props;
  return skipRender ? null : (
    <SignInFooter>
      Returning user?{' '}
      <Link
        href="/login"
        id="login"
        copyParams={['RelayState']}
        onClick={() => {
          maybeDiscover()?.returningUserClick();
          maybeActivationEmail()?.signInClick();
        }}
        testId={RETURNING_USER_TEST_ID}
      >
        Sign in
      </Link>
    </SignInFooter>
  );
};
